import {SprintApi} from '../network/sprint_api';
import {SprintsRepository} from '../persistence/sprints_repository';
import {Sprint} from '../models/sprint';

export class SprintUpdater {
    constructor(private sprintApi: SprintApi, private sprintRepository: SprintsRepository) {}

    public async update(sprintId: number, hours: number, isExtra: boolean) {
        const sprint = this.sprintRepository.find(sprintId);
        if (sprint !== null) {
            const updatedSprint: Sprint = {
                ...sprint,
                hours: hours,
                is_extra: isExtra,
            };
            const resultSprint = await this.sprintApi.update(updatedSprint);
            this.sprintRepository.store({
                ...updatedSprint,
                ...resultSprint,
            });
        }
    }
}
